import {
  getDiseaseItemColumnHeader,
  getVariantItemColumnHeader,
  getGeneItemColumnHeader,
  getGeneSecondColumnHeader,
  getChemicalColumnHeader,
  getResultColumnValue,
  getResultName,
} from './helpers/suggestionsTable.helpers';

const SuggestionsTable = ({
  suggestionsData,
  selectedItems,
  handleCheckboxSelection,
  searchType,
  selectedFilter,
}) => {
  if (!Array.isArray(suggestionsData) || suggestionsData.length === 0) return null;

  const uniqueResults = new Set();
  const uniqueNotFound = new Set();
  const uniqueValidationErrors = new Set();
  let rowNumber = 1;

  const renderColumnHeader = () => {
    switch (searchType) {
      case 'DISEASES':
        return (
          <>
            <th></th>
            <th>{getDiseaseItemColumnHeader(selectedFilter)}</th>
            <th>Disease Name</th>
            {selectedFilter !== 'diseaseName' && selectedFilter !== 'diseaseUMLSCUI' && <th>Disease CUI</th>}
            <th>Select</th>
          </>
        );
      case 'VARIANTS':
        return (
          <>
            <th></th>
            <th>{getVariantItemColumnHeader(selectedFilter)}</th>
            <th>Variant Gene</th>
            {selectedFilter !== 'strID' && <th>VARIANT rs number</th>}
            <th>Select</th>
          </>
        );
      case 'GENES':
        return (
          <>
            <th></th>
            <th>{getGeneItemColumnHeader(selectedFilter)}</th>
            <th>{selectedFilter === 'geneID' ? 'ENSEMBL ID' : 'Gene ID'}</th>
            <th>{getGeneSecondColumnHeader(selectedFilter)}</th>
            <th>Select</th>
          </>
        );
      case 'CHEMICALS':
        return (
          <>
            <th></th>
            <th>{getChemicalColumnHeader(selectedFilter)}</th>
            <th>Chemical Name</th>
            {selectedFilter !== 'CHEMBL' && <th>Chembl ID</th>}
            <th>Select</th>
          </>
        );
      default:
        return null;
    }
  };

  const renderValidationErrorRow = (item: any, index: any) => (
    <tr key={index} className="validation-error">
      <td style={{ color: 'red', fontStyle: 'italic' }}>{rowNumber++}</td>
      <td style={{ color: 'red', fontStyle: 'italic' }}>{item.query}</td>
      <td style={{ color: 'red', fontStyle: 'italic' }}>{item.validationError}</td>
      {searchType === 'DISEASES' &&
        selectedFilter !== 'diseaseName' &&
        selectedFilter !== 'diseaseUMLSCUI' && <td></td>}
      {searchType === 'GENES' && <td></td>}
      <td></td>
    </tr>
  );

  const renderNotFoundRow = (item: any, index: any) => {
    return (
      <tr key={index} className="validation-error">
        {selectedFilter === 'diseaseName' ? (
          <>
            <td style={{ color: 'red', fontStyle: 'italic' }}>{rowNumber++}</td>
            <td style={{ color: 'red', fontStyle: 'italic' }}>
              {item.validationError ? item.validationError : 'Not available'}
            </td>
            <td style={{ color: 'red', fontStyle: 'italic' }}>{item.query}</td>
            <td></td>
          </>
        ) : (
          <>
            <td style={{ color: 'red', fontStyle: 'italic' }}>{rowNumber++}</td>
            <td style={{ color: 'red', fontStyle: 'italic' }}>{item.query}</td>
            <td style={{ color: 'red', fontStyle: 'italic' }}>
              {item.validationError ? item.validationError : 'Not available'}
            </td>
            <td></td>
            <td></td>
          </>
        )}
      </tr>
    );
  };

  const renderResultRow = (result: any, index: any, i: any, query: any) => (
    <tr key={`${index}-${i}`}>
      <td>{rowNumber++}</td>
      <td>{getResultColumnValue(searchType, selectedFilter, result, query)}</td>
      <td>{getResultName(result, searchType)}</td>
      {searchType === 'DISEASES' &&
        selectedFilter !== 'diseaseName' &&
        selectedFilter !== 'diseaseUMLSCUI' &&
        renderSecondColumn(result)}
      {searchType === 'GENES' && renderSecondColumn(result)}
      {searchType === 'VARIANTS' && selectedFilter !== 'strID' && <td>{result.strID}</td>}
      {searchType === 'CHEMICALS' && selectedFilter !== 'CHEMBL' && <td>{result.chemID}</td>}
      <td>
        <input
          type="checkbox"
          name="selectedItem"
          value={result[selectedFilter]}
          checked={selectedItems.includes(result)}
          onChange={() => handleCheckboxSelection(result)}
          className="ml-3"
        />
      </td>
    </tr>
  );

  const renderSecondColumn = (result: any) => {
    if (searchType === 'DISEASES' || searchType === 'GENES') {
      if (searchType === 'DISEASES' && selectedFilter === 'diseaseUMLSCUI') {
        return <td></td>;
      }
      if (searchType === 'GENES' && selectedFilter === 'symbol') {
        return <td>{result.ensembl_ids || 'Not available'}</td>;
      }
      return (
        <td>
          {searchType === 'DISEASES'
            ? result.diseaseUMLSCUI || 'Not available'
            : result.symbol || 'Not available'}
        </td>
      );
    }
    return null;
  };

  return (
    <div className="suggestions-table">
      <table className="table panther-table" style={{ margin: '10px 20px 60px 10px' }}>
        <thead>
          <tr>{renderColumnHeader()}</tr>
        </thead>
        <tbody>
          {suggestionsData.map((item, index) => {
            if (item.validationError) {
              if (!uniqueValidationErrors.has(item.query)) {
                uniqueValidationErrors.add(item.query);
                return renderValidationErrorRow(item, index);
              }
              return null;
            }

            if (item.found && Array.isArray(item.results)) {
              return item.results
                .filter(result => {
                  const resultString = JSON.stringify(result);
                  if (uniqueResults.has(resultString)) {
                    return false;
                  }
                  uniqueResults.add(resultString);
                  return true;
                })
                .map((result: any, i: any) => renderResultRow(result, index, i, item.query));
            }

            if (!uniqueNotFound.has(item.query) && item.found === false) {
              uniqueNotFound.add(item.query);
              return renderNotFoundRow(item, index);
            }

            return null;
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SuggestionsTable;
